import { FORMS_REGISTER_ROUTE } from '../../../../../constants';
import Table from '../../../../Table';
import { FormAnswers } from '@bforms-web/common';
import { IconButton } from '@material-ui/core';
import { AttachFile as AttachFileIcon } from '@material-ui/icons';

const columns = [
  {
    key: 'formName',
    label: 'Formulário',
  },
  {
    key: 'patientName',
    label: 'Paciente',
  },
  {
    key: 'accreditedName',
    label: 'Clínica Credenciada',
  },
  {
    key: 'acceptedTerms',
    label: 'Termo Aceito',
    render: (value: boolean) => (value ? 'Sim' : 'Não'),
  },
  {
    key: 'termType',
    label: 'Status',
    render: (value: 'FILE_UPLOADED' | 'SIGNED_ON_APP') => {
      switch (value) {
        case 'FILE_UPLOADED':
          return 'Documento Enviado';
        case 'SIGNED_ON_APP':
          return 'Assinado';
        default:
          return 'Não informado';
      }
    },
  },
  {
    key: 'createdAt',
    label: 'Data Assinatura',
    render: (value: string) => new Date(value).toLocaleString(),
  },
  {
    key: 'formFiles',
    label: 'Documento',
    render: (formFiles: Array<{ id: string; name: string; url: string }>) => (
      <>
        {formFiles.map((file) => (
          <IconButton
            key={file.id}
            href={file.url}
            target="_blank"
            rel="noopener noreferrer"
            title={file.name}
          >
            <AttachFileIcon />
          </IconButton>
        ))}
      </>
    ),
  },
];

export type FormTableProps = {
  data: FormAnswers[];
  total: number;
  page?: number;
  rowsPerPage?: number;
  onChangePage?: (event: unknown, newPage: number) => void;
  onChangeRows?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemove?: (id: string) => void;
  canRemove?: boolean;
};

export default function FormTable({ 
  data, 
  total,
  page = 0,
  rowsPerPage = 10,
  onChangePage = () => {},
  onChangeRows = () => {},
  onRemove = () => {},
  canRemove = false
}: FormTableProps): JSX.Element {
  return (
    <Table
      columns={columns}
      data={data}
      title={'Consentimentos'}
      size="small"
      canAdd
      canRemove={canRemove}
      onRemove={onRemove}
      addRoute={FORMS_REGISTER_ROUTE}
      count={total}
      page={page}
      rowsPerPage={rowsPerPage}
      onChangePage={onChangePage}
      onChangeRows={onChangeRows}
    />
  );
}